import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FileItem } from '../file-transfer-v2/file-transfer-v2.component';

@Component({
  selector: 'app-source-files-panel',
  templateUrl: './source-files-panel.component.html',
  styleUrls: ['./source-files-panel.component.scss'],
})
export class SourceFilesPanelComponent {
  handleFolderShare(arg0: any, arg1: any) {
    throw new Error('Method not implemented.');
  }
  @Input() label: string;
  @Input() showSearchInput: boolean;
  @Input() searchQuery: string;
  @Input() filteredFolderContents: FileItem[] = [];
  @Input() fileCheckingComplete: boolean = false;
  @Input() sourceObjectName: string = '';
  @Input() currentFolderContents: FileItem[] = []; // Needed for empty folder message
  @Input() loadingFolderId: string | null = null;
  @Input() displayedItems: FileItem[] = []; // Add this to receive displayed items from parent
  @Input() subFolders: any[] = [];

  @Output() searchClioFilesEvent = new EventEmitter<string>();
  @Output() clearSearchEvent = new EventEmitter<void>();
  @Output() toggleFolderEvent = new EventEmitter<FileItem>();
  @Output() toggleFileSelectionEvent = new EventEmitter<{ item: FileItem; checked: boolean }>();
  @Output() toggleFolderSelectionEvent = new EventEmitter<{ folder: FileItem; checked: boolean }>();
  @Output() openClioFilePreviewEvent = new EventEmitter<FileItem>();

  constructor() {}

  // Local methods
  getDisplayedItems(): FileItem[] {
    return this.displayedItems || this.filteredFolderContents || [];
  }

  getItemDepth(item: FileItem): number {
    return item.depth || 0;
  }

  isFileAlreadyTransferred(file: FileItem): boolean {
    return file.alreadyTransferred || false;
  }

  isFolderSelected(folder: FileItem): boolean {
    return folder.selected || false;
  }

  areSomeFolderFilesSelected(folder: FileItem): boolean {
    return folder.partiallySelected || false;
  }

  hasFolderNonTransferredChildren(folder: FileItem): boolean {
    if (!folder.children || folder.children.length === 0) {
      return false;
    }
    return folder.children.some(child => !child.alreadyTransferred);
  }

  // Event emitters
  onSearchClioFiles(searchValue: string): void {
    this.searchClioFilesEvent.emit(searchValue);
  }

  onClearSearch(): void {
    this.clearSearchEvent.emit();
  }

  onToggleFolder(item: FileItem): void {
    this.toggleFolderEvent.emit(item);
  }

  onToggleFileSelection(item: FileItem, checked: boolean): void {
    this.toggleFileSelectionEvent.emit({ item, checked });
  }

  onToggleFolderSelection(folder: FileItem, checked: boolean): void {
    this.toggleFolderSelectionEvent.emit({ folder, checked });
  }

  onOpenClioFilePreview(item: FileItem): void {
    this.openClioFilePreviewEvent.emit(item);
  }
}
